import React, { PropsWithChildren, useMemo, useReducer } from 'react';

import {
  EMAILS_REDUCER_EVENT,
  EmailsContext,
  EmailsContextProps,
  EmailsViewState,
} from './EmailsContext.ts';

export type EmailsReducerAction =
  | EmailsReducerActionBasic<EMAILS_REDUCER_EVENT.SELECT_BOX, { folderId: string }>
  | EmailsReducerActionBasic<
      EMAILS_REDUCER_EVENT.SELECT_EMAIL,
      { selectedEmail: string; selectedThread: string }
    >
  | EmailsReducerActionBasic<
      EMAILS_REDUCER_EVENT.SELECT_THREAD,
      { selectedEmail: string; selectedThread: string } | null
    >;

type EmailsReducerActionBasic<TYPE extends EMAILS_REDUCER_EVENT, PAYLOAD extends object | null> = {
  payload: PAYLOAD;
  type: TYPE;
};

const emailsReducer = (state: EmailsViewState, action: EmailsReducerAction): EmailsViewState => {
  switch (action.type) {
    case EMAILS_REDUCER_EVENT.SELECT_BOX: {
      if (!action.payload) {
        throw new Error('Błąd przy wybieraniu skrzynki pocztowej');
      }
      return {
        ...state,
        selectedBox: action.payload,
        selectedEmail: null,
        selectedThread: null,
      };
    }
    case EMAILS_REDUCER_EVENT.SELECT_EMAIL: {
      const { selectedEmail, selectedThread } = action.payload;
      return {
        ...state,
        selectedEmail,
        selectedThread: selectedThread ?? state.selectedThread,
      };
    }
    case EMAILS_REDUCER_EVENT.SELECT_THREAD: {
      if (!action.payload) {
        return {
          ...state,
          selectedEmail: null,
          selectedThread: null,
        };
      }
      const { selectedEmail, selectedThread } = action.payload;
      return {
        ...state,
        selectedEmail,
        selectedThread,
      };
    }
  }
};

const initialEmailsViewState: EmailsViewState = {
  selectedBox: null,
  selectedEmail: null,
  selectedThread: null,
};

export const EmailsContextProvider: React.FC<PropsWithChildren> = props => {
  const [emailsState, updateEmailState] = useReducer(emailsReducer, initialEmailsViewState);

  const context: EmailsContextProps = useMemo(() => {
    return {
      emailsState,
      updateEmailState,
    };
  }, [emailsState]);

  return <EmailsContext.Provider value={context}>{props.children}</EmailsContext.Provider>;
};
